import i18n from '@/i18n';
import { supabase } from './supabase';

// The auth emails (reset, confirmation, …) are rendered by GoTrue from the
// templates in web/public/email/, which pick their language from the user's
// metadata (`user_metadata.locale`; English when missing or unsupported).
// So the language the user is actually reading the site in is mirrored there:
// on sign-in and whenever the UI language changes. Flutter does the same
// (lib/core/auth_locale.dart).

/** Two-letter code of the language the UI is showing right now. */
export function currentUiLocale(): string {
  const lang = i18n.resolvedLanguage || i18n.language || 'en';
  return (lang.split('-')[0] ?? 'en').toLowerCase();
}

/** Writes the current UI language to the signed-in user's metadata when it
 *  differs. Never throws — a failed write only means an English email. */
export async function syncAuthLocale(): Promise<void> {
  try {
    const { data } = await supabase.auth.getSession();
    const user = data.session?.user;
    if (!user) return;
    const code = currentUiLocale();
    if ((user.user_metadata as { locale?: string } | undefined)?.locale === code) return;
    const { error } = await supabase.auth.updateUser({ data: { locale: code } });
    if (error) console.warn('auth locale sync failed:', error.message);
  } catch (e) {
    console.warn('auth locale sync failed:', e);
  }
}
